"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATION_NAME_MAX_LENGTH = exports.ORGANIZATION_NAME_MIN_LENGTH = void 0;
exports.ORGANIZATION_NAME_MIN_LENGTH = 2;
exports.ORGANIZATION_NAME_MAX_LENGTH = 100;
